import { Text } from "@meditect/medibase-components";

export const SalesCannotCreateNewVersionOfOldSaleError = () => {
  return <Text>Impossible de créer une vente déjà existante</Text>;
};
